module.exports = __webpack_public_path__ + "img/password-changed.68e6b48e.svg";